import { useEffect } from "react";

const HOST =
  import.meta.env.VITE_FEEDBACK_HOST ||
  "https://dhc-repo-radar-production.up.railway.app";
const KEY =
  import.meta.env.VITE_FEEDBACK_KEY || "cea3a57481a78465767ecc0eef055737";

export function FeedbackWidget({
  user,
  repo,
}: {
  user?: { email?: string | null; name?: string | null };
  repo: string;
}) {
  const email = user?.email ?? undefined;
  const name = user?.name ?? undefined;

  useEffect(() => {
    const src = `${HOST}/widget.js`;
    let script = document.querySelector<HTMLScriptElement>(
      `script[data-dhc-feedback="true"]`,
    );

    const init = () => {
      const w = window as unknown as {
        DhcFeedback?: { init: (o: Record<string, unknown>) => void };
      };
      w.DhcFeedback?.init({ repo, key: KEY, user: { email, name } });
    };

    if (script) {
      // Already loaded earlier — (re)init with current user.
      init();
      return;
    }

    script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.dataset.dhcFeedback = "true";
    script.addEventListener("load", init);
    document.body.appendChild(script);
  }, [repo, email, name]);

  return null;
}
